<template>
  <UCard :ui="carouselCardFiveWithBorder">
    <TLazyimg
      :src="item.image"
      alt=""
      classes-img="object-cover w-full h-full rounded-t-lg"
      classes="aspect-w-4 aspect-h-3"
    />
    <div class="p-4">
      <TTitle tag="h3" size="2xl" class="mb-0">
        {{ item.title }}
      </TTitle>
      <TText tag="div" size="sm" clamp="clamp3" classes="text-ellipsis mb-4">
        {{ item.description }}
      </TText>
      <UButton
        color="primary"
        variant="solid"
        :to="item.button.url"
        :label="item.button.text"
        class="mt-4 group"
        external
      />
    </div>
  </UCard>
</template>
<script setup lang="ts">
import { carouselCardFiveWithBorder } from '~~/modules/design-system/utils/nuxt-ui-config/components/card'

export interface SCardsWideProps {
  item: {
    image: string
    title: string
    description: string
    button: {
      text: string
      url: string
    }
  }
}

defineProps<SCardsWideProps>()
</script>
